var map = {
	"./ALDEAO.jpg": "e571",
	"./ALDEAO_V2.jpg": "7f4b",
	"./BEBADO.jpg": "2fec",
	"./BEBADO_V2.jpg": "e147",
	"./BRUXA.jpg": "f863",
	"./CACADOR.jpg": "81d5",
	"./FERREIRO.jpg": "ce40",
	"./FORASTEIRO.jpg": "cb74",
	"./MEDICO.jpg": "261e",
	"./PADRE.jpg": "cfcf",
	"./PROTETOR.jpg": "feda",
	"./VAMPIRO.jpg": "b293",
	"./VAMPIRO_V2.jpg": "3854",
	"./WHORE.jpg": "f4d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";